import type { IntlShape } from "@formatjs/intl";
import type { Dispatch } from "@reduxjs/toolkit";
import { Drawer } from "antd";
import type { TicketData } from "../TicketViewRender";
import { CreateReportWizard } from "./CreateReportWizard";

type CreateReportDrawerProps = {
  open: boolean;
  onClose: () => void;
  ticketData: TicketData;
  dispatch: Dispatch;
  intl: IntlShape;
};

export function CreateReportDrawer({
  open,
  onClose,
  ticketData,
  dispatch,
  intl,
}: CreateReportDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={intl.formatMessage({ id: "wo_report_title" })}
      styles={{ wrapper: { width: "min(960px, 100vw)" } }}
      destroyOnHidden
    >
      {/* rendered per opening, so selections start empty every time */}
      <CreateReportWizard
        ticketData={ticketData}
        dispatch={dispatch}
        intl={intl}
        onClose={onClose}
      />
    </Drawer>
  );
}
